import { Story } from '../../types/story';

export const berlinFirstTime: Story = {
  id: 'berlin-first-time',
  title: 'First Time in Berlin',
  excerpt: 'Years of fantasies finally become reality when a nervous American meets a confident stranger in a Kreuzberg bar.',
  city: 'Berlin',
  publishDate: '2026-01-02',
  readTime: '10 min read',
  tags: ['♂♂', 'first-time', 'bar', 'intense'],
  categories: ['queer', 'intense'],
  intensity: 2,
  content: `Berlin was supposed to be where I figured myself out.

I'd spent twenty-eight years in the closet—well, half-closet. I'd come out to friends, posted rainbow flags during Pride, even had a few awkward coffee dates with guys from apps. But when it came to actually doing anything? I froze.

The problem was, I was also a coward.

I'd never even kissed a guy, let alone dropped to my knees for one. I'd fantasized about it, though—oh, I'd fantasized. I'd lie in bed at night, imagining some faceless, hung stranger grabbing my hair, shoving himself down my throat while I gagged and drooled like a good little slut. I'd imagine the weight of him on my tongue, the way my jaw would ache, the way he'd groan and call me filthy names. I'd come so hard to those thoughts that I'd have to bite my pillow to keep from making noise.

But in real life? I froze. Every. Single. Time.

I'd go to bars, eye up the biggest guy in the room, and then immediately retreat to the bathroom to jerk off in a stall like a loser. I'd sign up for dating apps, match with guys who had "generous" in their bios, and then ghost them before we could even meet. I'd tell myself I wasn't ready, that I needed more time, that I'd do it next weekend.

But the truth was, I was terrified.

What if I choked? What if I gagged too much? What if I wasn't good at it? What if, after all these years of obsession, the reality didn't live up to the fantasy?

So I moved to Berlin. Because if you can't figure out your sexuality in Berlin, you're probably hopeless.

The bar was in Kreuzberg, all exposed brick and dim lighting, the kind of place where everyone looked like they'd just come from a rave or were about to go to one. I was nursing my third beer, working up the courage to actually talk to someone, when I saw him.

Jake.

He was across the bar, laughing with his friends, his jeans so tight I could practically see the outline of his dick. My mouth went dry. He was exactly the kind of guy I'd avoid in real life—cocky, loud, the type who probably had a line of guys waiting to suck him off. The kind of guy who'd laugh in my face if he knew how inexperienced I was.

But that night, something in me snapped.

Maybe it was the beer on an empty stomach. Maybe it was the way he caught me staring and didn't look away, just smirked like he knew what I was thinking. Or maybe I was just sick of being a virgin in every way that mattered.

He sauntered over, all swagger and smirk, his dark eyes locked onto mine. "You look like you're about to pass out," he said, his voice low and rough, with just a hint of a German accent.
“I’m fine,” I lied, my voice coming out higher than I intended.
“Yeah?” He leaned in, close enough that I could smell his cologne—something expensive, something that made my stomach clench. “Then why are you staring at my crotch like it’s Christmas morning?”
I should’ve been embarrassed. I should’ve stammered, looked away, made up some excuse about how I was actually just zoning out. But I didn’t.
“"I'm not," I said, lifting my chin just a little. "I'm staring because I want to see what's in there."

Jake's grin turned sharp, predatory. "Bold for a guy who looks like he's never done this before."

"I haven't."

"Then what makes you think you can handle it?"

I swallowed hard, my pulse hammering in my throat. "I don't know. But I want to try."

He studied me for a second, his gaze flicking down to my lips and then back up to my eyes. Then, without a word, he grabbed my wrist and pulled me off my stool.

"Come on. There's a courtyard out back."

I followed him like a dog.

The courtyard was dark, lit only by a single bulb over the back door. I could hear the muffled bass from inside, the distant sound of traffic on Oranienstraße. Berlin at night—alive, electric, anonymous.

The second we were outside, he pushed me against the wall, his body pressing into mine. I could feel how hard he was, even through his jeans. My pulse was hammering in my throat, my cock already half-hard just from the anticipation.
“You sure about this?” he asked, his voice rough, his breath hot against my ear.
I nodded frantically. “Yes. Please.”
“Say it.”
“I’m sure.”
He unbuttoned his jeans and pulled out his cock.
Holy fuck.
It was everything I’d ever wanted—thick, veiny, the head already wet with precome. My mouth watered. I reached for it, but he slapped my hand away.
“Not yet.” He grabbed my hair, yanking my head back just enough to make me gasp. “You want this? You’re gonna earn it.”
I whimpered, my cock twitching in my jeans.
He shoved my head down.
The first time my lips touched him, I thought I was gonna come right then. He tasted salty, musky, real. I kissed the head, then the shaft, my tongue tracing the veins, memorizing the way he twitched under my touch. Jake groaned, his grip tightening in my hair.
“Open.”
I did.
He pushed in.

It was nothing like I’d imagined.
The stretch, the weight, the way he hit the back of my throat—it was overwhelming. I gagged, tears pricking my eyes, but I didn’t stop. I hollowed my cheeks, bobbed my head, my hands gripping his thighs for balance. My jaw ached, my lips burned, but I didn’t care. I wanted more.
“Fuck, you’re eager,” Jake growled, his voice rough with pleasure.
I moaned around him, the vibration making him curse.
“That’s it, take it,” he encouraged, his hips rocking forward just a little. “You look so fucking good with your lips wrapped around my cock.”
I whimpered, my cock throbbing painfully in my jeans. I wanted to touch myself, but I didn’t dare move my hands from where they were clutching at his thighs.
Then he pulled me off.
“Stand up.”
I did, confused and a little dizzy. He spun me around, pressing me against the wall again. His cock was still out, still hard, and he rubbed it against my ass through my jeans.
“You like that?” he asked, grinding into me.
“Yes,” I gasped.
He spat into his hand, then reached around and undid my jeans. Before I could process what was happening, he had my cock out, stroking me in time with his thrusts.
I nearly collapsed.
The friction, the pressure—it was too much. I came with a broken cry, spilling over his fingers. Jake followed soon after, his cock pulsing against my ass, his breath hot against my neck.
We stood there for a second, panting. Then he pulled away, tucking himself back in. He turned me around, his expression unreadable.
“You’re a mess,” he said, wiping his thumb over my bottom lip.
I was. My lips were swollen, my hair a disaster, my jeans still undone, my cock softening but still sticky with come.
“You good?” he asked.
I nodded, my cheeks burning.
He smirked. “Yeah, you are.” He leaned in, kissing me hard, his tongue pushing into my mouth like he owned it. “You ever think about doing that again?”
“Every fucking day.”
He laughed, then pulled out his phone. “Give me your number.”
I did.
He didn’t call me that night. Or the next.
But two days later, my phone buzzed.
Jake: You free tonight?
I grinned.
Me: For what?
Jake: For me to fuck that pretty mouth again.
I didn’t even hesitate.
Me: Yes.

That night, I met him at his place in Neukölln.

The apartment was small, messy but lived-in—typical Berlin Altbau with high ceilings and creaky wooden floors. The second I walked in, he had me against the door, his mouth on mine, his hands roaming over my body like he was claiming it.
“You’ve been thinking about this, haven’t you?” he murmured against my lips.
“Yes,” I admitted, my voice breathless.
“About my cock in your mouth?”
“Yes.”
“About me fucking your throat until you can’t breathe?”
I whimpered. “Yes.”
He smirked. “Good.”
He led me to his bedroom, pushing me onto the bed. He stripped off his shirt, then his jeans, his cock already hard again. I reached for him, but he shook his head.
“Not yet.” He crawled onto the bed, straddling my chest. “I want you to beg for it.”
I swallowed hard. “Please.”
“Please what?”
“Please let me suck you.”
He grinned. “Since you asked so nicely.”
He fed me his cock, and this time, I took him deeper, my throat opening for him like it was made for it. I gagged, tears streaming down my face, but I didn’t stop. I wanted to please him. I wanted to show him I could take it.
“Fuck, you’re such a good little slut,” he groaned, his hips rocking forward. “Look at you, taking my cock like you were born for it.”
I moaned, the words sending a jolt of pleasure straight to my cock.
He fucked my mouth until I was a drooling, gasping mess, until my jaw ached and my lips were raw. And when he finally came, it was with a groan, his come spilling down my throat as I swallowed every last drop.
Afterward, he collapsed beside me, pulling me into his arms.
“You’re a natural,” he murmured, pressing a kiss to my forehead.
I smiled, my body humming with satisfaction.
“"You ever think about doing more than just sucking?" he asked, his hand trailing down my chest, over my stomach, lower.

I hesitated. "I don't know."

He smirked. "We'll see. You're in Berlin now. Plenty of time to explore."

And just like that, I wasn’t a coward anymore.

I was his.

At least for tonight. And maybe tomorrow. And maybe the night after that.

Berlin had a way of making you brave.`
};
